import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../../shared/constant";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import FeaturedPropertiesSliderItem from "./featured-properties-slider-item.component";

const options = {
  loop: true,
  margin: 30,
  dots: true,
  nav: false,
  rtl: "false",
  autoplayHoverPause: false,
  autoplay: false,
  singleitem: "true",
  smartspeed: 1200,
  navText: [
    '<i class="fa fa-arrow-left"></i>',
    '<i class="fa fa-arrow-right"></i>',
  ],
  responsive: {
    0: {
      items: 1,
      center: false,
    },
    480: {
      items: 1,
      center: false,
    },
    600: {
      items: 1,
      center: false,
    },
    768: {
      items: 2,
    },
    992: {
      items: 2,
    },
    1200: {
      items: 2,
    },
    1280: {
      items: 3,
    },
  },
};

const FeaturedPropertiesSlider = () => {
  const [featuredPropertiesItems, setFeaturedPropertiesItems] = useState(false);

  useEffect(() => {
    axios
      .get(API_URL.FEATURE_PROPERTY)
      .then((response) => {
        if (response.status === 200) {
          setFeaturedPropertiesItems(response.data.data);
        }
      })
      .catch((err) => {
        console.log("Error from Featured PropertiesList");
      });
  }, []);

  return (
    <section id="feature-property" className="feature-property bgc-f7">
      <div className="container ovh">
        <div className="row">
          <div className="col-lg-6 offset-lg-3">
            <div className="main-title text-center mb40">
              <h2>Featured Properties</h2>
              <p>Handpicked properties by our team.</p>
            </div>
          </div>
          <div className="col-lg-12">
            {featuredPropertiesItems ? (
              <OwlCarousel className="feature_property_slider" {...options}>
                {featuredPropertiesItems.map((property) => (
                  <FeaturedPropertiesSliderItem
                    key={property.property_id}
                    property={property}
                  />
                ))}
              </OwlCarousel>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedPropertiesSlider;
